// extracted by mini-css-extract-plugin
export default {"link":"List_link__8q5Ys"};